import {HubConnectionState} from '@microsoft/signalr';
import mitt from 'mitt';
import {useEffect} from 'react';

const emitter = mitt();

type SubscriptionEventMap = {
  __NEVER__: undefined;
  'session-expired': undefined;
  'document-listing': undefined;
  'review-log': undefined;
  'signalr-state-changed': HubConnectionState;
  'tracked-sn-listing': undefined;
  'rig-listing': undefined;
};

export type SubscriptionEvents = keyof SubscriptionEventMap;

export function useSubscription(
  eventName: SubscriptionEvents,
  cb: (event: SubscriptionEventMap[SubscriptionEvents]) => void,
): void {
  useEffect(() => {
    emitter.on(eventName as any, cb as any);
    return () => emitter.off(eventName as any, cb as any);
  });
}

export function notify(
  eventName: SubscriptionEvents,
  event: SubscriptionEventMap[SubscriptionEvents],
) {
  emitter.emit(eventName, event);
}
